import React from 'react';
import { Button } from '../../ui/button';

interface FollowUpProps {
  questions: string[];
  onSelect: (question: string) => void;
}

export const FollowUpSuggestions: React.FC<FollowUpProps> = ({
  questions,
  onSelect
}) => {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="mt-6 space-y-3">
      <div className="flex items-center gap-2">
        <span className="text-sm">💭</span>
        <p className="text-sm font-medium text-foreground/90">Suggested follow-ups:</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {questions.map((question, i) => (
          <Button
            key={i}
            variant="outline"
            size="sm"
            className="text-sm px-3 py-2 h-auto bg-muted/30 hover:bg-primary/10 hover:border-primary/30 hover:text-primary transition-all duration-200 rounded-lg border-border/40"
            onClick={() => onSelect(question)}
          >
            <span className="text-left leading-relaxed">{question}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default FollowUpSuggestions;